import { CostScoreCardDepartmentDetailView } from './costScoreCardDepartmentDetailView/CostScoreCardDepartmentDetailView';
import { CostScoreCardDepartmentVariant } from '../../enums/CostScoreCardDepartmentVariant.enum';
import { GroupEntity } from '@backstage/catalog-model';
import { OverspendCard } from '../overspendCard/OverspendCard';
import { Progress } from '@backstage/core-components';
import { getCategoryColor } from '../../helpers/colors';
import { useDepartmentCostSummary } from '../../hooks/useDepartmentCostSummary';
import { useEntity } from '@backstage/plugin-catalog-react';
import { useTeamList } from '@internal/ui-common';

interface CostScoreCardDepartmentProps {
  variant: CostScoreCardDepartmentVariant;
}

function CostScoreCardDepartment({ variant }: CostScoreCardDepartmentProps) {
  const { entity: departmentGroup } = useEntity<GroupEntity>();
  const { teams, isLoading } = useTeamList(departmentGroup);
  const { value: costSummary, isLoading: costDataLoading } =
    useDepartmentCostSummary(teams);

  if (isLoading || costDataLoading) {
    return <Progress />;
  }

  if (variant === CostScoreCardDepartmentVariant.Overview) {
    const hasCostData = (costSummary?.teams ?? []).length > 0;
    const color =
      hasCostData && costSummary?.color
        ? costSummary.color
        : getCategoryColor('nodata');

    return (
      <OverspendCard
        color={color}
        overspend={costSummary?.totalOverspend ?? 0}
        title="Cost Overspend"
        hasCostData={hasCostData}
      />
    );
  }

  return (
    <CostScoreCardDepartmentDetailView
      teams={teams}
      costSummary={
        costSummary ?? {
          teams: [],
          totalOverspend: 0,
          color: getCategoryColor('nodata'),
        }
      }
    />
  );
}

export { CostScoreCardDepartment };
